import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Divider, Button } from '@ets/design-system';

import { useDispatch, useSelector } from '_common/hooks';
import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';
import { clearFilterIdentity, useFilterSelector } from '../../FilterSlice';
import Filters, { FiltersProps } from '../../Filters';

import styles from './FilterContent.module.scss';

type FilterContentProps = FiltersProps & {
  persist?: boolean;
};

const FilterContent = ({ identity, persist, ...props }: FilterContentProps) => {
  const dispatch = useDispatch();
  const { selectAppliedFilterCount } = useFilterSelector();

  const appliedFilterCount = useSelector((state) =>
    selectAppliedFilterCount(state, state.filters[identity]),
  );

  useEffect(() => {
    if (!persist) {
      return () => {
        dispatch(clearFilterIdentity({ identity, noFeedback: true }));
      };
    }
  }, [persist]);

  const handleClearAllFilters = () => {
    dispatch(clearFilterIdentity({ identity }));
  };

  return (
    <>
      <IntlErrorBoundary size="xs" style={{ margin: 'auto 2.25rem' }}>
        <div className={styles.root}>
          <div className={styles.header}>
            <div className={styles.title}>
              <FormattedMessage id="FILTERS" />
            </div>
            <Button
              size="s"
              variant="link"
              style={{ margin: '0 0 0 0.5rem' }}
              onClick={handleClearAllFilters}
              disabled={!appliedFilterCount}
              testId={`${identity}-filterPopover-clearAll`}
            >
              <FormattedMessage id="CLEAR_ALL" />
            </Button>
          </div>
          <Divider margin="0" />
          <div className={styles.filterList}>
            <Filters identity={identity} testId={`${identity}-filterPopover`} {...props} />
          </div>
        </div>
      </IntlErrorBoundary>
    </>
  );
};

export default FilterContent;
